import { useTranslation } from 'react-i18next';
import { $deleteRecipientStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Button, Icon, Text } from '@shared/widgets';
import FilledTrashIcon from '@assets/icons/filled-trash.svg';

interface DeleteRecipientModalProps {
  isOpen: boolean;
  onClose: () => void;
  id?: string | number;
}

export const DeleteRecipientModal = (props: DeleteRecipientModalProps) => {
  const { navigate } = useRouteHook();

  const { t } = useTranslation('recipient');

  const removeReceipt = async () => {
    const response = await $deleteRecipientStore.events.delete(props.id as string);
    if (response.success) navigate(RoutePaths.payments.onNavigate());
  };

  if (!props.isOpen) return null;
  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
      <div className='w-full max-w-[556px] bg-white px-24 py-14 shadow-lg dark:bg-eerie-black'>
        <Icon icon={<FilledTrashIcon />} className='mb-6 flex justify-center' color='primary' />
        <div className='text-center'>
          <Text className='mb-2' weight='semibold' size='2xl'>
            {t('details.modals.deleteRecipient.title')}
          </Text>
          <Text className='mb-6'>{t('details.modals.deleteRecipient.description')}</Text>
          <div className='flex justify-center gap-3'>
            <Button color='outlined' fullWidth onClick={props.onClose}>
              {t('buttons.cancel', { ns: 'common' })}
            </Button>
            <Button color='primary' fullWidth onClick={removeReceipt}>
              {t('details.modals.deleteRecipient.buttons.deleteRecipient')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
